// leave off @2x/@3x
const images = {
  carAera: require('../images/car-aera/map-car-aera.png'),
  noImage: require('../images/placeHolder/no-image.png'),
};

export default images;
